export const TINK_ERROR_FLAG = "tinkError";

const TINK_ERROR_STORAGE_PREFIX = "lea_tink_error_message";

/** In-memory cache so React Strict Mode remounts can re-read after consume. */
const displayCache = new Map<string, string>();

const buildStorageKey = (flowId: string): string =>
	`${TINK_ERROR_STORAGE_PREFIX}:${flowId}`;

export const storeTinkErrorMessage = (
	flowId: string,
	message: string
): void => {
	if (typeof window === "undefined") return;

	const normalized = message.trim();
	if (!normalized) return;

	displayCache.set(flowId, normalized);
	sessionStorage.setItem(buildStorageKey(flowId), normalized);
};

/**
 * Reads the Tink error message for `flowId` without clearing it. Hydrates the
 * in-memory cache from sessionStorage on first read so remounts stay stable.
 */
export const peekTinkErrorMessage = (flowId: string): string | undefined => {
	if (typeof window === "undefined") return undefined;

	const cached = displayCache.get(flowId);
	if (cached) return cached;

	const key = buildStorageKey(flowId);
	const value = sessionStorage.getItem(key)?.trim();
	if (!value) return undefined;

	displayCache.set(flowId, value);
	return value;
};

export const clearTinkErrorMessage = (flowId: string): void => {
	displayCache.delete(flowId);
	if (typeof window === "undefined") return;
	sessionStorage.removeItem(buildStorageKey(flowId));
};
